import ACTIONS, { FETCH_STATUS } from "../constants";

export const loginAttempt = {
  pending: {
    type: ACTIONS.LOGIN.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.LOGIN.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error, isMfa) => ({
    type: ACTIONS.LOGIN.ERROR,
    error,
    isMfa,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getLoginRequest = (state) => ({
  type: ACTIONS.LOGIN_CALL,
  payload: state,
});

export const forgotPasswordRequest = (state) => ({
  type: ACTIONS.FORGOT_PASSWORD_CALL,
  payload: state,
});

export const forgotPasswordAttempt = {
  pending: {
    type: ACTIONS.FORGOT_PASSWORD.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.FORGOT_PASSWORD.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.FORGOT_PASSWORD.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const resetPasswordRequest = (state) => ({
  type: ACTIONS.RESET_PASSWORD_CALL,
  payload: state,
});

export const resetPasswordAttempt = {
  pending: {
    type: ACTIONS.RESET_PASSWORD.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESET_PASSWORD.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESET_PASSWORD.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const resetLoginActionsRequest = (state) => ({
  type: ACTIONS.RESET_LOGIN_ACTIONS_CALL,
  payload: state,
});

export const resetLoginActionsAttempt = {
  pending: {
    type: ACTIONS.RESET_LOGIN_ACTIONS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESET_LOGIN_ACTIONS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESET_LOGIN_ACTIONS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const logoutSucceed = () => ({
  type: ACTIONS.AUTH_LOGOUT,
});

export const callLogout = () => ({
  type: ACTIONS.AUTH_LOGOUT_BEGIN,
});

export const fetchLogoRequest = (state) => ({
  type: ACTIONS.FETCH_LOGO_BEGIN,
  payload: state,
});

export const fetchLogoAttempt = {
  pending: {
    type: ACTIONS.FETCH_LOGO.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.FETCH_LOGO.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.FETCH_LOGO.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const resetErrorMesage = () => ({
  type: ACTIONS.RESET_ERROR_MESSAGE,
});

export const authenticatedUser = (state) => ({
  type: ACTIONS.AUTHENTICATED_USER,
  data: state,
});
